import React from "react";
import { Button, Icon } from "semantic-ui-react";
import { lrP10 } from "./ApplicationsCalendar.module.css";
const CalendarHeader = ({
  prevYear,
  nextYear,
  prevMonth,
  nextMonth,
  title,
  ...props
}) => {
  return (
    <div {...props}>
      <div className={lrP10}>
        <Button onClick={prevYear} icon className={lrP10}>
          <Icon name="angle double left" />
          <span></span>
        </Button>
      </div>
      <div>
        <Button onClick={prevMonth} icon>
          <Icon name="angle left" />
          <span></span>
        </Button>
      </div>
      <div className={lrP10} style={{display:"flex", minWidth:"150px"}}>
        <div style={{margin:"auto"}}>{title}</div>
      </div>
      <div>
        <Button onClick={nextMonth} icon className={lrP10}>
          <Icon name="angle right" />
          <span></span>
        </Button>
      </div>
      <div>
        <Button onClick={nextYear} icon className={lrP10}>
          <Icon name="angle double right" />
          <span></span>
        </Button>
      </div>
    </div>
  );
};

export default CalendarHeader;
